<script>
	import request from '@/axios/index'
	import {getDic} from '@/api/dic.js'
	const state = {
		buyOrSell:'seller',
		goldDetailPrarms:null, //祺信融资页面祺信详情各组件间通用数据
		financingDetailPrarms:null,
		dicStore:{},
		modfyMobileOrEmail:"" //关于身份验证的填写信息

	};

	const mutations = {
		setBuyOrSell: function(state,data) {
			state.buyOrSell = data;
		},
		setGoldDetailPrarms: function(state,data) { 
			state.goldDetailPrarms = data; 
		},
		setFinancingDetailPrarms: function(state,data) { 
			state.financingDetailPrarms = data; 
		},
		setDic: function(state,data) { 
			state.dicStore[data.type] = data.info; 
		},
		setDic: function(state,data) { 
			state.dicStore[data.type] = data.info; 
		},
		setModfyMobileOrEmail: function(state,data) { 
			state.modfyMobileOrEmail = data||""; 
		},
	};

	const getters = {
		getBuyOrSell:function(state){
			return state.buyOrSell;
		},
		getGoldDetailPrarms:function(state){
			return state.goldDetailPrarms;
		},
		getFinancingDetailPrarms:function(state){
			return state.financingDetailPrarms;
		},
		getModfyMobileOrEmail:function(state){
			return state.modfyMobileOrEmail;
		}
	};

	const actions = {
		getDicAsync({dispatch,commit,state},type){
			return new Promise((resolve,reject) => {
				if(state.dicStore[type] && state.dicStore[type].length > 0){
					resolve(state.dicStore[type]);
					return;
				}
				getDic({dctTpCd:type})
				.then((res) => {
					commit("setDic",{type:type,info:res.data});
					resolve(res.data);
				})
				.catch((err)=>{
					console.log(err);
				});
			})	
		},
	};

	export default {
		namespaced: true,
		state,
		getters,
		mutations,
		actions
	}
</script>


// WEBPACK FOOTER //
// src/store/app_store.vue